import { useSearchParams } from "react-router-dom";

export const useToken = () => {
  const [searchParams] = useSearchParams();
  return searchParams.get("token") as string;
};
